
// ─────────────────────────────────────────────────────────
// DEFAULT VALUES
// ─────────────────────────────────────────────────────────
const DEFAULT_VALUES = {
  fillColor:   "rgba(255,255,255,0.4)",
  strokeColor: "#3399CC",
  strokeWidth: 1.25,
  circleRadius: 5,
  lineCap:     "round",
  lineJoin:    "round",
  dashEnabled: false,
  dashLength:  10,
  dashGap:     5,
  lblEnabled:    false,
  lblMode:       "attribute",
  lblTextValue:  "",
  fontFamily:    "sans-serif",
  fontSize:      12,
  fontStyle:     "normal",
  fontColor:     "#333333",
  textAlign:     "center",
  baseline:      "middle",
  placement:     "point",
  offsetX:       0,
  offsetY:       0,
  rotation:      0,
  haloEnabled:   false,
  haloColor:     "#ffffff",
  haloWidth:     2,
  overflow:      false,
};

// ─────────────────────────────────────────────────────────
// FLAT STYLE BUILDER — reads plain values object
// ─────────────────────────────────────────────────────────
const buildFlatStyle = (geomType, v) => {
  // Merge provided values with defaults
  const values = { ...DEFAULT_VALUES, ...v };
  const style = {};
  const gt = (geomType || "").toLowerCase();

  if (gt === "point") {
    style["circle-radius"]       = values.circleRadius;
    style["circle-fill-color"]   = values.fillColor;
    style["circle-stroke-color"] = values.strokeColor;
    style["circle-stroke-width"] = values.strokeWidth;
  } else if (gt === "linestring" || gt === "multilinestring") {
    style["stroke-color"]     = values.strokeColor;
    style["stroke-width"]     = values.strokeWidth;
    style["stroke-line-cap"]  = values.lineCap;
    style["stroke-line-join"] = values.lineJoin;
    if (values.dashEnabled) style["stroke-line-dash"] = [values.dashLength, values.dashGap];
  } else {
    style["fill-color"]       = values.fillColor;
    style["stroke-color"]     = values.strokeColor;
    style["stroke-width"]     = values.strokeWidth;
    style["stroke-line-cap"]  = values.lineCap;
    style["stroke-line-join"] = values.lineJoin;
    if (values.dashEnabled) style["stroke-line-dash"] = [values.dashLength, values.dashGap];
  }

  if (values.lblEnabled && values.lblTextValue) {
    let textVal;
    if (values.lblMode === "attribute")       textVal = ["get", values.lblTextValue];
    else if (values.lblMode === "expression") { try { textVal = JSON.parse(values.lblTextValue); } catch { textVal = values.lblTextValue; } }
    else                                  textVal = values.lblTextValue;

    style["text-value"]        = textVal;
    style["text-font"]         = `${values.fontStyle} ${values.fontSize}px ${values.fontFamily}`;
    style["text-fill-color"]   = values.fontColor;
    style["text-stroke-color"] = values.haloEnabled ? values.haloColor : "transparent";
    style["text-stroke-width"] = values.haloEnabled ? values.haloWidth : 0;
    style["text-align"]        = values.textAlign;
    style["text-baseline"]     = values.baseline;
    style["text-placement"]    = values.placement;
    style["text-offset-x"]     = values.offsetX;
    style["text-offset-y"]     = values.offsetY;
    style["text-overflow"]     = values.overflow;
    style["text-rotation"]     = (values.rotation * Math.PI) / 180;
  }
  return style;
};


export {buildFlatStyle, DEFAULT_VALUES};